export const defaultFilterConfiguration = {
  isActive: true,
  isDeactivated: false,
  keyword: '',
};



// WEBPACK FOOTER //
// ./src/common/components/filter/Filters.constants.js